module.exports = __webpack_public_path__ + "static/img/gpt13.36504533.png";